function updateSaleCountdown() {
  // Set the daily end time (e.g., 11:59 PM)
  const now = new Date();
  const endTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59); // 11:59:59 PM today

  // Calculate the time left until the end of the day
  const timeLeft = endTime - now;

  if (timeLeft > 0) {
    const days = String(Math.floor(timeLeft / (1000 * 60 * 60 * 24))).padStart(2, '0');
    const hours = String(Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0');
    const minutes = String(Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0');
    const seconds = String(Math.floor((timeLeft % (1000 * 60)) / 1000)).padStart(2, '0');

    const timeElements = {
      days: { value: days, label: "Days" },
      hours: { value: hours, label: "Hours" },
      minutes: { value: minutes, label: "Minutes" },
      seconds: { value: seconds, label: "Seconds" },
    };

     // Iterate over each .sale-timer element
    document.querySelectorAll('.sale-timer').forEach(saleTimer => {
      // Check if the parent of the current .sale-timer has the class 'below-buttons-timer'
      const isBelowButtonsTimer = saleTimer.parentElement.classList.contains('below-buttons-timer');
    
      // Update each time element within the current .sale-timer
      saleTimer.querySelectorAll('.time').forEach(element => {
        const unit = element.classList[1]; // 'days', 'hours', 'minutes', or 'seconds'
        // Conditionally add the label based on the parent class
        element.innerHTML = isBelowButtonsTimer
          ? `<span class="value">${timeElements[unit].value}</span> <span class="units">${timeElements[unit].label}</span>`
          : `${timeElements[unit].value}`;
      });
    });

  } else {
    document.querySelector('.sale-timer').style.display = "none!important";
  }
}

setInterval(updateSaleCountdown, 1000);
